import { isUndNullEmp } from '../../../helpers/main.js';

export class DocumentService {
    constructor(
        _docType = '',
        _docNumber = 0,
        _docStatus = false,
        _docDate = '',
        _docExpiration = '',
        _docServicesDNS = '',
        _docServicesEndDateStr = '',
        _docServicesEndDate = '',
        _docCustomerId = '',
        _docOriginType = '',
        _docOriginNumber = 0,
        _docCommentary = '',
        _docItemId = '',
        _docItemDescription = '',
        _docQuantity = 0,
        _docCost = 0,
        _docRengNet = 0,
        _docSalePriceValue = 0,
        _docSalePriceDate = '',
        _docServisRemainingDays = 0,
    ) {
        this.docType = _docType;
        this.docNumber = _docNumber;
        this.docStatus = _docStatus;
        this.docDate = _docDate;
        this.docExpiration = _docExpiration;
        this.docServicesDNS = _docServicesDNS;
        this.docServicesEndDateStr = _docServicesEndDateStr;
        this.docServicesEndDate = _docServicesEndDate;
        this.docCustomerId = _docCustomerId;
        this.docOriginType = _docOriginType;
        this.docOriginNumber = _docOriginNumber;
        this.docCommentary = _docCommentary;
        this.docItemId = _docItemId;
        this.docItemDescription = _docItemDescription;
        this.docQuantity = _docQuantity;
        this.docCost = _docCost;
        this.docRengNet = _docRengNet;
        this.docSalePriceValue = _docSalePriceValue;
        this.docSalePriceDate = _docSalePriceDate;
        this.docServisRemainingDays = _docServisRemainingDays;
    }

    static getClassName = () => {
        return 'DocumentService - class';
    }

    static getClass = (obj = {}, upperCase = false) => {
        if (!isUndNullEmp({ data: obj, subMethod: this.getClassName() })?.result) {
            if (upperCase) {
                return new DocumentService(
                    obj.DocType,
                    obj.DocNumber,
                    obj.DocStatus,
                    obj.DocDate,
                    obj.DocExpiration,
                    obj.DocServicesDNS,
                    obj.DocServicesEndDateStr,
                    obj.DocServicesEndDate,
                    obj.DocCustomerId,
                    obj.DocOriginType,
                    obj.DocOriginNumber,
                    obj.DocCommentary,
                    obj.DocItemId,
                    obj.DocItemDescription,
                    obj.DocQuantity,
                    obj.DocCost,
                    obj.DocRengNet,
                    obj.DocSalePriceValue,
                    obj.DocSalePriceDate,
                    obj.DocServisRemainingDays,
                );
            } else {
                return new DocumentService(
                    obj.docType,
                    obj.docNumber,
                    obj.docStatus,
                    obj.docDate,
                    obj.docExpiration,
                    obj.docServicesDNS,
                    obj.docServicesEndDateStr,
                    obj.docServicesEndDate,
                    obj.docCustomerId,
                    obj.docOriginType,
                    obj.docOriginNumber,
                    obj.docCommentary,
                    obj.docItemId,
                    obj.docItemDescription,
                    obj.docQuantity,
                    obj.docCost,
                    obj.docRengNet,
                    obj.docSalePriceValue,
                    obj.docSalePriceDate,
                    obj.docServisRemainingDays,
                );
            }
        } else {
            return new DocumentService();
        }
    }
}